import React from 'react';

function SelectLanguage() {
  return <select-language useApi="false" />;
}

export default SelectLanguage;
